export default __webpack_public_path__ + "static/media/logo_tgv_inoui.c2e04b5d.svg";